export const steps = {
  step_one: 1,
  step_two: 2,
  step_three: 3,
  step_four: 4,
  step_five: 5,
  step_six: 6,
};

export const PAGINATION_DEFAULTS = {
  pageSize: 20,
  current: 1,
  hideOnSinglePage: true,
  showTitle: false,
};
